import {AfterViewInit, Component, OnInit, Renderer2} from "@angular/core";
import {ScrollHelper} from "../../common/helpers/scrollHelper";
import {NgForm} from "@angular/forms";
import {RNSService} from "../../services/RNS.service";
import {RNSStatus} from "../../objects/pars-status-widget/RNS-status";
import {RNSStatusModel} from "../../objects/pars-status-widget/RNS-status-model";
import {EmailService} from "../../services/emailService";
import {ToastsManager} from "ng2-toastr";
import { RNSResponse } from "../../objects/pars-status-widget/rns-response";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: "pars-status-widget",
    templateUrl: "./pars-status-widget.component.html",
    styleUrls: ['../../../theme/scss/pars-status-widget.scss'],
    moduleId: module.id.toString()
})
export class ParsStatusWidgetComponent implements OnInit, AfterViewInit{

    public statusNames: Map<RNSStatus, string> = new Map<RNSStatus, string>([
        [ RNSStatus.Other, "Number Not On File" ],
        [ RNSStatus.Error, "Number Not On File" ],
        [ RNSStatus.NumberNotOnFile, "Pending Clearance" ],
        [ RNSStatus.DeclarationAccepted, "Approved - ready to cross" ],
        [ RNSStatus.GoodsReleased, "Released" ],
        [ RNSStatus.GoodsRequiredForExamination, "Held for examination" ],
    ]);

    public spinner: HTMLElement;

    public rnsStatusModel: RNSStatusModel;
    public rnsStatus = RNSStatus;

    public isShowStatForm: boolean = true;
    public isShowGetNotified:  boolean = false;
    public isStatusUpdates: boolean = false;
    public isStatusReleased: boolean = false;
    public isSubscribedSuccess: boolean = false;
    public currentStatus: string;

    public pendingClearanceDateTimeStamp: string;
    public approvedDateTimeStamp: string;
    public heldToExaminationDateTimeStamp: string;
    public releasedDateTimeStamp: string;

    private ccn: string;

    private ccnUnsub: string;
    private email: string;
    public unsubscribe: boolean;

    constructor(private renderer: Renderer2,
                private rnsService: RNSService,
                private emailService: EmailService,
                public toastsManager: ToastsManager,
                private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.ccnUnsub = this.route.snapshot.queryParams['ccn'] || "";
        this.email = this.route.snapshot.queryParams['email'] || "";
        const unsub = this.route.snapshot.queryParams['unsubscribe'] || "";
        this.unsubscribe = unsub === "1";
    }

    ngAfterViewInit() {
       this.spinner = document.getElementById("spinner");
       this.renderer.addClass(this.spinner, "hide");

       ScrollHelper.forceSetVerticalScroll(document.getElementsByTagName('body')[0]);

       if(this.unsubscribe) {
           this.emailService.unsubscribeEmail(this.ccnUnsub, this.email).then(_ => {});
       }
    }

    public onSubmit(ccnForm: NgForm): void {

        if(ccnForm.valid) {

            this.renderer.removeClass(this.spinner, "hide");
            const ccn = ccnForm.value.ccn.trim();
            this.submitCcn(ccn);
        }

        ccnForm.resetForm();
    }

    public onSubscribeSubmit(subscribeForm: NgForm): void {

        if(subscribeForm.valid) {

            this.renderer.removeClass(this.spinner, "hide");

            this.emailService.sendSubscribeToPARSStatus(this.ccn.trim(), subscribeForm.value.email.trim()).then((r) => {
                this.isStatusUpdates = false;
                this.isShowGetNotified = false;
                this.isShowStatForm = false;
                this.isSubscribedSuccess = true;
                this.renderer.addClass(this.spinner, "hide");
            },reject => {
                this.toastsManager.error(reject.Data.Message || reject.Data);
                this.renderer.addClass(this.spinner, "hide");
            });
        }

        subscribeForm.form.markAsTouched();
    }

    public onCheckAnotherShipmentFormSubmit(checkAnotherShipmentForm: NgForm): void {

        if(checkAnotherShipmentForm.valid) {

            this.renderer.removeClass(this.spinner, "hide");

            const ccn = checkAnotherShipmentForm.value.anotherParsNumber;
            this.submitCcn(ccn);
        }

        checkAnotherShipmentForm.resetForm();
    }

    private submitCcn(ccn: string): void {
        this.ccn = ccn;
        this.rnsService.CheckCCN(this.ccn).then(r => {
            this.rnsStatusModel = r.Data;
            this.isShowStatForm = false;
            this.isSubscribedSuccess = false;
            this.isStatusReleased = false;

            if (this.rnsStatusModel == null) {
                this.isStatusUpdates = true;
                this.isStatusReleased = false;
                this.isShowGetNotified = false;
            } else {
                this.currentStatus = this.statusNames.get(this.rnsStatusModel.CurrentStatus);
                this.isStatusUpdates = false;
                this.isShowGetNotified = true;
                this.isStatusReleased = this.rnsStatusModel.CurrentStatus == RNSStatus.GoodsReleased;

                this.pendingClearanceDateTimeStamp = this.getStatusTimeStamp(RNSStatus.NumberNotOnFile);
                this.approvedDateTimeStamp = this.getStatusTimeStamp(RNSStatus.DeclarationAccepted);
                this.heldToExaminationDateTimeStamp = this.getStatusTimeStamp(RNSStatus.GoodsRequiredForExamination);
                this.releasedDateTimeStamp = this.getStatusTimeStamp(RNSStatus.GoodsReleased);
            }

            this.renderer.addClass(this.spinner, "hide");
        },reject => {
            this.toastsManager.error(reject.Data);
            this.renderer.addClass(this.spinner, "hide");
        });
    }

    private getStatusTimeStamp(status: RNSStatus | undefined): string | undefined {

        if (status == undefined)
            return undefined;

        const filteredByStatus = this.getRNSStatusResponseByStatus(status);

        if (filteredByStatus.length > 0){
            let statusRecord = this.getFirstRNSResponse(filteredByStatus);

            if (statusRecord){
                return statusRecord.DateTimeStamp;
            }
        }

        return this.getStatusTimeStamp(this.getNextRNSStatusResponse(status));
    }

    private getNextRNSStatusResponse(currentStatus: RNSStatus): RNSStatus | undefined{
        return RNSStatus[RNSStatus[currentStatus + 1]];
    }

    private getRNSStatusResponseByStatus(status: RNSStatus): RNSResponse[]{
        return this.rnsStatusModel.StatusHistory.filter(x => x.Status == status);
    }

    private getFirstRNSResponse(responseArray: RNSResponse[]): RNSResponse{
        return responseArray.sort((x,y) => (new Date(x.ReceivedDate)).getTime() - (new Date(y.ReceivedDate)).getTime())[0];
    }
}



// WEBPACK FOOTER //
// ./app/components/pars-status-widget/pars-status-widget.component.ts